export default {
  resetState ({ commit }) {
    commit('resetState')
  }
}
